import TaskApi from './rest/TaskApi';

export default new TaskApi();
